import { useEffect } from "react";
import { updateGlobalContext } from "../../components/context/GlobalContext";
import { stringify } from "../../utils/helpers";

export const useTitle = (title?: string, show: boolean = true) => {
  useEffect(() => {
    if (show) updateGlobalContext({ title: stringify(title) });
  }, [title]);
};
